import styled from "styled-components";

export const StyledPhoneLink = styled.a`
    display: flex;
    justify-content: space-between;
    gap: 12px;
    color: ${({ theme }) => theme.primaryTypographyColor};
`;
